$(document).ready(function(){
  ////

  // http://www.cosmosoft.fr/cosmoAPI/passerelle/Passerelle-test-.xml
  // http://www.cosmosoft.fr/cosmoAPI/passerelle/passerelle2.php?xi=Mzg3ejo2T0U0ODY4Yjp0ZXN0OmRlZmF1bHRfZW5j

  var mapVille = {}
  var resultSearchVille = [];
  var resultType = [];
  var resultPrice = [];
  var size = '';
  var order = '';

  var inc = 300;

  function detectmob() {
    if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ){
      return true;
    }
    else {
      return false;
    }
  }

  var detectmob = detectmob();

  $('#offres a').each(function(){
    var ville = $(this).find('.content h4').text();
    if(mapVille[ville] === undefined){
      mapVille[ville] = [this.id]
    }else{
      mapVille[ville].push(this.id)
    }
  })


  if($(window).width() > 920){

    $('.item img').each(function(){
      $(this).resizeToParent();
    })
    size = 'desktop'
  }else{
    size = 'mobile'
  }


  $(window).resize(function(){
    if($(window).width() > 920 && size === 'mobile'){
      size = 'desktop'
      $('.item img').each(function(){
        $(this).resizeToParent();
      })

    }else if($(window).width() <= 920 && size === 'desktop'){
      size = 'mobile'
      $('.item img').each(function(){
        $(this).attr('style','');
        var parent = $(this).parent();
        $( this ).clone().prependTo(parent);
        $(this).remove();
      })

    }

  })

  ////////// FADE IN ////////////

  setTimeout(function(){
    $('#fade-0').addClass('show');
  },400)


  $(window).scroll( function(){

    fadeIn();

  });

  function fadeIn(){
    /* Check the location of each desired element */
    $('.fade').each( function(i){

        var bottomElt = $(this).offset().top + $(this).outerHeight();
        var bottomWindow = $(window).scrollTop() + $(window).height();

        /* If the object is completely visible in the window, fade it it */
        if(!detectmob){
          if( bottomWindow+inc > bottomElt ){

              $(this).addClass('show');

          }
        }else{

          if( $(window).scrollTop()+inc > $(this).offset().top ){

              $(this).addClass('show');

          }

        }

    });
  }

  //////////////////////////////

  $("#sortBy").click(function(){
    $(this).next().toggleClass("open")
  })

  $('#sortBy+.options').mouseleave(function(){
    $(this).removeClass("open")
  })

  $("#sortBy+.options #asc").click(function(){
    if(order !== 'asc'){
      $(this).addClass("selected")
      $('#sortBy+.options #desc').removeClass("selected")
      order = 'asc'
      sortBy(order);
    }
    $(this).parent().parent().removeClass('open')

  })

  $("#sortBy+.options #desc").click(function(){
    if(order != 'desc'){
      $(this).addClass("selected")
      $('#sortBy+.options #asc').removeClass("selected")
      order = 'desc'
      sortBy(order);
    }
    $(this).parent().parent().removeClass('open')
  })

  $('#search-ville').keyup(function(e){
    if($(this).val() === ''){
      resultSearchVille = [];
      setTimeout(function(){
        $('#fade-0').addClass('show');
      },400)
    }else if($(this).val().length>2){
      filterVille($(this));
    }
    renderOffres();

  });

  $("#bien").click(function(){
    $(this).next().toggleClass("open")
    $("#prix+.options").removeClass("open")
  })

  $('#bien+.options').mouseleave(function(){
    $(this).removeClass("open")
  })

  $('#bien+.options li').click(function(e){
    if(!$(this).hasClass('selected')){
      filterType($(this));
      console.log();
    }else{
      resultType = [];
      $(this).removeClass('selected');
    }
    $(this).parent().parent().removeClass('open')
    renderOffres();
  })

  $("#prix").click(function(){
    $(this).next().toggleClass("open")
    $("#bien+.options").removeClass("open")
  })

  $('#prix+.options').mouseleave(function(){
    $(this).removeClass("open")
  })

  $('#prix+.options li').click(function(e){
    if(!$(this).hasClass('selected')){
      filterPrice($(this));
    }else{
      resultPrice = [];
      $(this).removeClass('selected');
    }
    $(this).parent().parent().removeClass('open')
    renderOffres();
  })

  function filterPrice(elt){
    var selected = elt[0].id;
    $('#prix+.options li').each(function(){
      if(this.id === selected){
        $(this).addClass("selected")
      }else{
        $(this).removeClass("selected")
      }
    });
    var symbol = selected.substring(0,1);
    var price = selected.substring(1,selected.length);
    price = price.replace(' ','')
    price = parseFloat(price);
    var result = []

    $('#offres a').each(function(){

      var priceAffaire = $(this).find('.price').text();
      priceAffaire = priceAffaire.replace(/\s/g,'')
      priceAffaire = priceAffaire.replace('€','')
      priceAffaire = parseFloat(priceAffaire)

      if( symbol === '<'){
        if(priceAffaire < price){
          result.push(this.id);
        }
      }else{
        if(priceAffaire > price){
          result.push(this.id);
        }
      }


    });

    if(result.length === 0){
      resultPrice = null;
    }else{
      resultPrice = result;
    }

  }

  function filterType(elt){
    var selected = elt.text();
    $('#bien+.options li').each(function(){
      if($(this).text() === selected){
        $(this).addClass("selected")
      }else{
        $(this).removeClass("selected")
      }
    });

    var result = []

    $('#offres a').each(function(){

      var typeAffaire = $(this).find('.type').text().toLowerCase();

      if(typeAffaire === selected.toLowerCase()){
        result.push(this.id);
      }

    });


    if(result.length === 0){
      resultType = null;
    }else{
      resultType = result;
    }

  }

  function filterVille (elt){
    var search = elt.val().toLowerCase();
    var result = [];
    for (var key in mapVille) {
      var match = key.toLowerCase();
      match = match.substring(0,search.length);
      if(match === search){
        result.push(mapVille[key]);
      }

    }

    resultSearchVille = _.sortBy( _.flatten(result));

    if(resultSearchVille.length === 0){
      resultSearchVille = null;
    }else{
      resultSearchVille = _.flatten(result);
    }


  }

  function renderOffres(){
    var result = null;
    var notFilted = false;

    if(resultType === null || resultPrice === null || resultSearchVille === null){
      $('.result').text("Aucun résultat");
      $('#offres a').each(function(){
        $(this).addClass("hide");
      });
      return false;
    }

    if(resultSearchVille.length > 0 && resultType.length > 0 && resultPrice.length > 0){
      // console.log('tous');
      result = intersection(resultSearchVille , resultType, resultPrice);
    }else if(resultSearchVille.length > 0 && resultType.length === 0 && resultPrice.length === 0){
      // console.log("seulement ville");
      result = resultSearchVille;
    }else if(resultSearchVille.length === 0 && resultType.length > 0 && resultPrice.length === 0){
      // console.log("seulement type");
      result = resultType;
    }else if(resultSearchVille.length === 0 && resultType.length === 0 && resultPrice.length > 0){
      // console.log("seulement prix");
      result = resultPrice;
    }else if(resultSearchVille.length > 0 && resultType.length > 0 && resultPrice.length === 0){
      // console.log("ville et type");
      result = intersection(resultSearchVille , resultType);
    }else if(resultSearchVille.length > 0 && resultType.length === 0 && resultPrice.length > 0){
      // console.log("ville et prix");
      result = intersection(resultSearchVille , resultPrice);
    }else if (resultSearchVille.length === 0 && resultType.length > 0 && resultPrice.length > 0) {
      result = intersection(resultType , resultPrice);
    }else{
      console.log("aucun");
      $('.result').text("");

      notFilted = true;
    }

    if(!notFilted){
      result = _.flatten(result);
      $('.result').text(result.length+" biens correspondants");

      // console.log(resultType, resultSearchVille);


      $('#offres a').each(function(){
        var id = this.id

        $(this).removeClass("show");

        // setTimeout(function(){
        //   fadeIn();
        // },400);


        var found = _.find(result,function(d){
          return d === id
        })


        if(found === undefined){
          $(this).addClass("hide");
        }else{
          $(this).removeClass("hide");
        }

      })

      setTimeout(function(){
        $("#"+result[0]).addClass("show");
      },300)

    }else{

      setTimeout(function(){
        $("#offres a:nth-child(1)").addClass("show");
      },300);

      $('#offres a').each(function(i,n){
        $(this).removeClass("hide");
      });

    }


  }

  var intersection = function(){
    return Array.from(arguments).reduce(function(previous, current){
      return previous.filter(function(element){
        return current.indexOf(element) > -1;
      });
    });
  };

  var sortBy = function(order){

    var elts= [];

    $('#offres a').each((i,n)=>{
      $(n).removeClass('show')
      var price = $(n).find(".price").html();
      price = price.replace(/ /g,"");
      price = price.replace("€","");
      price = parseInt(price);
      elts.push({price, obj : n.outerHTML})
    })

    elts = _.sortBy(elts,(elt)=>{
      return elt.price
    })

    if(order === 'desc'){
      elts.reverse();
    }

    document.getElementById('offres').innerHTML = ''


    elts.forEach((i,n)=>{
      $('#offres').append(i.obj)
    })

    setTimeout(function(){
      $("#offres").children('a:not(.hide)').first().addClass("show");
    },300);

  }

})



// WEBPACK FOOTER //
// ./src/js/offres.js